import React from 'react';
import { Space, Tag, Typography } from 'antd';
import { formatMoney } from '@/utils/format';

const { Text } = Typography;

export interface EpcEstimateStatusStripProps {
  currency?: string | null;
  revisionStatus?: string | null;
  /** Cost model readiness (READY ≠ Pricing READY). */
  costModel?: string | null;
  /** Commercial pricing readiness. */
  pricing?: string | null;
  /** Approval Runtime revision status / approved flag. */
  approved?: boolean;
  /** Submission basis CERTIFIED / CERTIFIABLE / etc. */
  submissionBasis?: string | null;
  /** Award / proposal pin present. */
  pinned?: boolean;
  /** Original project cost budget generated. */
  originalBudgetGenerated?: boolean;
  tec?: number | null;
}

/**
 * Distinct control-chain states — do not collapse into a single badge.
 */
export const EpcEstimateStatusStrip: React.FC<EpcEstimateStatusStripProps> = ({
  currency,
  revisionStatus,
  costModel,
  pricing,
  approved,
  submissionBasis,
  pinned,
  originalBudgetGenerated,
  tec,
}) => {
  const basis = String(submissionBasis || 'NOT_CERTIFIED');
  const certified = basis === 'CERTIFIED' || basis === 'CERTIFIABLE';

  return (
    <Space wrap size={[8, 8]} align="center">
      {tec != null && Number.isFinite(Number(tec)) ? (
        <Text>
          TEC{' '}
          <Text strong>
            {formatMoney(tec, { display: 'plain', maximumFractionDigits: 0 })}
            {currency ? ` ${currency}` : ''}
          </Text>
        </Text>
      ) : null}
      {revisionStatus ? <Tag>{revisionStatus}</Tag> : null}
      <Tag color={costModel === 'READY' ? 'green' : 'orange'}>
        Cost Model {costModel || '…'}
      </Tag>
      <Tag color={pricing === 'READY' ? 'green' : 'orange'}>
        Pricing {pricing || 'NOT_STARTED'}
      </Tag>
      <Tag color={approved ? 'green' : 'default'}>{approved ? 'APPROVED' : 'Not approved'}</Tag>
      <Tag color={basis === 'CERTIFIED' ? 'green' : certified ? 'blue' : 'default'}>
        {basis === 'CERTIFIED' ? 'CERTIFIED' : `Basis ${basis}`}
      </Tag>
      <Tag color={pinned ? 'purple' : 'default'}>{pinned ? 'PINNED' : 'Not pinned'}</Tag>
      <Tag color={originalBudgetGenerated ? 'green' : 'default'}>
        {originalBudgetGenerated ? 'Original Budget GENERATED' : 'Original Budget pending'}
      </Tag>
    </Space>
  );
};
